var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.4,414.1c34.3,19.1,68.7,38.2,103,57.2c14.8,8.2,21.3,25.6,15.4,41.5c-29.5,80.7-116,123.3-197.4,93.6 c-166.6-60.8-290.2-184.4-351-351C49.8,174,92.4,87.5,173,58c15.9-5.8,33.3,0.7,41.5,15.4c19.1,34.3,38.1,68.7,57.2,103 c8.9,16.1,6.8,35.2-5.4,49c-16,18-32.1,36.1-48.1,54.1c34.2,83.3,104.8,153.9,188.1,188.1c18-16,36-32.1,54.1-48.1 C474.2,407.2,493.3,405.1,509.4,414.1L509.4,414.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8fa732ebc6440d74c18481a2c9e1d1f8.svg";
export { ForwardRef as ReactComponent };